"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _Settings = require("./Settings");
var _upload = _interopRequireDefault(require("cccisd-icons/upload2"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Thumbnail = function Thumbnail(_ref) {
  var _ref$settings = _ref.settings,
    settings = _ref$settings === void 0 ? _Settings.initialSettings : _ref$settings;
  if (!settings) {
    return null;
  }
  var imageUrl = settings.imageUrl,
    imageStyle = settings.imageStyle,
    imageWidth = settings.imageWidth;
  if (!imageUrl) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].thumbnail
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].icon
    }, /*#__PURE__*/_react["default"].createElement(_upload["default"], null)));
  }
  var coverBgStyles = {
    backgroundImage: "url(".concat(imageUrl, ")"),
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat'
  };
  var tileBgStyles = {
    backgroundImage: "url(".concat(imageUrl, ")"),
    backgroundSize: imageWidth
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].thumbnail,
    style: imageStyle === 'cover' ? coverBgStyles : tileBgStyles
  });
};
var _default = exports["default"] = Thumbnail;